<script lang="ts">
  import Icon from "@iconify/svelte"
  import logo_mark from "@images/logo/logo-mark-white.png"
  import logo from "@images/logo/logo-white.png"
  import { type Snippet } from "svelte"

  let {
    children,
    current_user
  }: { children: Snippet; current_user?: UserType } = $props()
</script>

<svelte:head>
  <script
    async
    src="https://www.googletagmanager.com/gtag/js?id=G-RXGMN2WVWL"
  ></script>
  <script>
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())

    gtag("config", "G-RXGMN2WVWL")
  </script>
</svelte:head>

<div class="flex flex-col h-screen">
  <nav class="bg-lwp-accent">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-24">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center mr-8">
            <a href="/">
              <img
                src={logo_mark}
                class="block lg:hidden h-16 w-auto"
                alt="Lead With Purpose"
              />
              <img
                src={logo}
                class="hidden lg:block h-16 w-auto"
                alt="Lead With Purpose"
              />
            </a>
          </div>
        </div>
        <div class="flex justify-center items-center">
          {#if current_user}
            <a
              href="/users/sign_out"
              class="max-w-xs bg-indigo-200 hover:bg-indigo-800 flex whitespace-nowrap items-center text-lg py-3 px-4 text-indigo-700 hover:text-white rounded font-bold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
              >SIGN OUT</a
            >
          {/if}
        </div>
      </div>
    </div>
  </nav>

  <main class="lg:relative bg-lwp-blue flex-grow">
    {@render children()}
  </main>

  <footer class="bg-lwp-accent mt-auto" aria-labelledby="Footer">
    <div class="mx-auto py-4 px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-3 gap-4 xl:gap-8">
        <div
          class="flex justify-center md:justify-start items-center col-span-3 md:col-span-1"
        >
          <div class="p-2">
            <a
              href="https://www.facebook.com/LeadWithPurpose"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white hover:text-gray-200"
            >
              <span class="sr-only">Facebook</span>
              <Icon icon="jam:facebook-circle" class="h-10 w-10" />
            </a>
          </div>
          <div class="p-2">
            <a
              href="https://www.instagram.com/leadwithpurpose/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white hover:text-gray-200"
            >
              <span class="sr-only">Instagram</span>
              <Icon icon="jam:instagram" class="h-10 w-10" />
            </a>
          </div>
          <div class="p-2">
            <a
              href="https://www.linkedin.com/company/lead-with-purpose/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white hover:text-gray-200"
            >
              <span class="sr-only">LinkedIn</span>
              <Icon icon="jam:linkedin-circle" class="h-10 w-10" />
            </a>
          </div>
          <div class="p-2">
            <a
              href="https://www.youtube.com/user/LeadWithPurpose/videos"
              target="_blank"
              rel="noopener noreferrer"
              class="text-white hover:text-gray-200"
            >
              <span class="sr-only">YouTube</span>
              <Icon icon="jam:youtube-circle" class="h-10 w-10" />
            </a>
          </div>
        </div>
        <div class="flex items-center justify-start">
          <img src={logo_mark} class="h-8 md:h-14 md:mx-auto" alt="logo" />
        </div>
        <div class="flex items-center justify-end col-span-2 md:col-span-1">
          <div class="w-full">
            <p class="text-sm md:text-base text-white text-right">
              2012-{new Date().getFullYear()} &copy; Lead With Purpose, Inc.
            </p>
            <p class="text-base text-white text-right">
              <a
                href="/terms"
                class="text-sm md:text-base text-right text-white hover:text-blue-200"
              >
                Terms of Use
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
